export const DEFAULT_ASPECT_RATIO = 4 / 3
export const MODAL_ROOT = 'modal-root'
